import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
import LoginPage from "@/components/LoginPage";
import ForgotPassword from "@/components/ForgotPassword";
import SelectOrganization from "@/components/SelectOrganization.vue";
import EmployeeProfile from "@/components/ESSProfile/EmployeeProfile.vue"
import Settings from "@/components/ESSProfile/EmpSettings.vue"
import Tasks from "@/components/ESSProfile/Tasks.vue"
import EmployerTimesheets from "@/components/ESSProfile/EmployerTimesheets.vue"
import TimesheetsListView from "@/components/ESSProfile/Timesheets/TimesheetsListView.vue"
import MyTimesheets from "@/components/ESSProfile/MyTimesheets.vue"
import AddTimesheets from "@/components/ESSProfile/Timesheets/AddTimesheets.vue"
import TaskDetails from "@/components/ESSProfile/Tasks/TaskDetails.vue"
import EmpChangeTimezone from "@/components/ESSProfile/ESSSettings/EmpChangeTimezone.vue"
import EmpProfileSettings from "@/components/ESSProfile/ESSSettings/EmpProfileSettings.vue"
import EmpAlertSettings from "@/components/ESSProfile/ESSSettings/EmpAlertSettings.vue"

import FDNS from "@/components/ESSProfile/EmpFDNSFiles.vue"
import EmployeeSpecificQuestions from "@/components/ESSProfile/FDNS/FDNSTabs/EmployeeSpecificQuestions.vue"
import FDNSVisitHistoryTab from "@/components/ESSProfile/FDNS/FDNSTabs/FDNSVisitHistoryTab/FDNSVisitHistoryTab.vue"
import ReportFDNSVisit from "@/components/ESSProfile/FDNS/ReportFDNSVisit.vue"

import ReportingEmployees from "@/components/ESSProfile/ReportingEmployees.vue"

import Leavemanagement from "@/components/ESSProfile/Leavemanagement.vue"
import Notification from "@/components/ESSProfile/Notification.vue"
import AlertViewAll from "@/components/ESSProfile/AlertViewAll.vue"
import ESSDashboard from "@/components/ESSProfile/ESSDashboard.vue"
import H1BPetitionEmpChecklistDocs from "@/components/ESSProfile/EmpH1B/H1BPetitionEmpChecklistDocs.vue"

import AddNewProject from "@/components/ESSProfile/ESSProjects/AddNewProject.vue"
import PageNotFound from "@/components/PageNotFound.vue";
import HealthCheck from "@/components/HealthCheck.vue";
import CallbackPage from "@/components/Callback.vue";
import LoginRedirect from "@/components/LoginRedirection.vue";
import DCAAReports from "@/components/ESSProfile/Timesheets/DCAAReports.vue"
import EmployeePopup from "@/components/ESSProfile/Timesheets/EmployeePopup.vue"
import c from "Vue/Core/constants.js";
Vue.use(Router);

const router = new Router({
    base: '/',
    mode: 'history',
    linkActiveClass: 'active',
    routes: [{
            path: "/",
            // name: "LoginPage",
            // component: LoginPage,
            name: LoginRedirect,
            component: LoginRedirect,
            meta: {
                title: 'OnBlick ESS - Sign In'
            }
        },
        {
            path: "/ForgotPassword",
            name: "ForgotPassword",
            component: ForgotPassword,
            meta: {
                title: 'OnBlick ESS - Forgot Password'
            }
        },
        {
            path: "/callback",
            name: "callback",
            component: CallbackPage,
            meta: {
                title: 'OnBlick ESS - Login'
            }
        },
        {
            path: "/SelectOrganization",
            name: "SelectOrganization",
            component: SelectOrganization,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Select Organization'
            }

        },

        // Employee Module - ESS

        {

            path: "/employee",
            component: EmployeeProfile,
            children: [{
                    path: '',
                    name: "employee-details",
                    component: require('@/components/ESSProfile/EmpDetails.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee Details'
                    }
                },
                {
                    name: "employee-projects",
                    path: 'projects',
                    component: require('@/components/ESSProfile/EmpProjects.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee Projects'
                    }
                },
                {
                    name: "employee-resume",
                    path: "resume",
                    component: require('@/components/ESSProfile/EmpResume.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee Resume'
                    }
                },
                {
                    name: "employee-notes",
                    path: "notes",
                    component: require('@/components/ESSProfile/EmpNotes.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee Notes'
                    }

                },
                {
                    name: "employee-h1b",
                    path: "h1b",
                    component: require('@/components/ESSProfile/EmpH1B.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee H-1B'
                    }
                },
                {
                    name: "employee-i9",
                    path: "i9",
                    component: require('@/components/ESSProfile/EmpFormI9.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee I-9'
                    }
                },
                {
                    name: "employee-form-i983",
                    path: "form-i983",
                    component: require('@/components/ESSProfile/FormI983.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee Form I-983'
                    }
                },
                {
                    name: "employee-form-i539",
                    path: "form-i539",
                    component: require('@/components/ESSProfile/FormI539.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee Form I-539'
                    }
                },
                
                {
                    name: "employee-ead",
                    path: "ead",
                    component: require('@/components/ESSProfile/EmpEAD.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee EAD'
                    }
                },
                {
                    name: "employee-gc",
                    path: "gc",
                    component: require('@/components/ESSProfile/EmpGreenCard.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee Green Card'
                    }
                },
                {
                    name: "employee-L1visa",
                    path: "l1visa",
                    component: require('@/components/ESSProfile/EmpL1Visa.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee L1VISA'
                    }
                },
                {
                    name: "employee-E3Visa",
                    path: "e3visa",
                    component: require('@/components/ESSProfile/EmpE3Visa.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee E3VISA'
                    }
                },
                {
                    name: "employee-TNVisa",
                    path: "tnvisa",
                    component: require('@/components/ESSProfile/EmpTNVisa.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee TNVISA'
                    }
                },


            ]
        },
        //Tasks

        {
            path: "/evaluation",
            component: Tasks,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Employee Tasks'
            },
            children: [{
                    path: "",
                    name: "evaluation",
                    props: true,
                    component: require('@/components/ESSProfile/Tasks/Evaluation.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Evaluation'
                    }
                },
                {
                    path: "/employee-tasks",
                    name: "employee-tasks",
                    props: true,
                    component: require('@/components/ESSProfile/Tasks/Task.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS -Tasks '
                    }
                }
            ]
        },

        //Timesheets
        {
            name: "employer-timesheets",
            path: "/employer-timesheets",
            component: EmployerTimesheets,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Employee Timesheets'
            }
        },
        //Timesheets List View
        {
            name: "timesheets-list",
            path: "/timesheets-list",
            component: TimesheetsListView,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Employee Timesheets List View'
            }
        },
        //Alerts view all
        {
            name: "employer-alerts",
            path: "/employer-alerts",
            component: AlertViewAll,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Employee Alerts'
            }
        },

        // Notification
        {
            path: "/notification",
            name: "notification",
            component: Notification,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Employee Notificaitons'
            }
        },

        //MyTimesheets
        {
            name: "my-timesheets",
            path: "/my-timesheets",
            component: MyTimesheets,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - My Timesheets'
            }
        },
        //dcaa reports
        {
            name: "dcaa-reports",
            path: "/dcaa-reports",
            component: DCAAReports,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - DCAAReports'
            }
        },
        //Timesheet Activity Log
        // {
        //     name: "employee-activitylog",
        //     path: "/employee-activitylog",
        //     component: EmployeeActivityLog,
        //     meta: {
        //         requiresAuth: true,
        //         title: 'OnBlick ESS - Employee ActivityLog'
        //     }
        // },
         //Supervisior Activity Log
        //  {
        //     name: "supervisior-activitylog",
        //     path: "/supervisior-activitylog",
        //     component: SupervisiorActivityLog,
        //     meta: {
        //         requiresAuth: true,
        //         title: 'OnBlick ESS - SuperVisior ActivityLog'
        //     }
        // },
        //employee log
        {
            name: "employee-popup",
            path: "/employee-popup",
            component: EmployeePopup,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Employee Popup'
            }
        },


        //Add Timesheets

        {
            name: "employee-addtimesheets",
            path: "/employee-addtimesheets",
            component: AddTimesheets,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Employee AddTimesheets'
            }
        },

        //Leavemanagement
        {
            path: "/leave-management",
            component: Leavemanagement,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Employee Leavemanagement'
            },
            children: [{
                    path: "",
                    name: "leave-management",
                    props: true,
                    component: require('@/components/ESSProfile/LeaveManagement/ApplyLeave.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS -ApplyLeave '
                    }
                },
                {
                    path: "/leave-count",
                    name: "leave-count",
                    props: true,
                    component: require('@/components/ESSProfile/LeaveManagement/LeaveCount.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - LeaveCount'
                    }
                },
                {
                    path: "/leave-history",
                    name: "leave-history",
                    props: true,
                    component: require('@/components/ESSProfile/LeaveManagement/LeaveHistory.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - LeaveHistory'
                    }
                },
                {
                    path: "/leave-policy",
                    name: "leave-policy",
                    props: true,
                    component: require('@/components/ESSProfile/LeaveManagement/LeavePolicy.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - LeavePolicy'
                    }
                },
                {
                    path: "/holiday-list",
                    name: "holiday-list",
                    props: true,
                    component: require('@/components/ESSProfile/LeaveManagement/HolidayList.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - HolidayList'
                    }
                }
            ]
        },

        //Tasks-details

        {
            name: "employee-tasks-details",
            path: "/employee-tasks-details/:id",
            component: TaskDetails,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Employee Tasks'
            }
        },

        {
            path: "/settings",
            component: Settings,
            children: [{
                        path: '',
                        name: "employee-profile",
                        component: EmpProfileSettings, // require('@/components/ESSProfile/ESSSettings/EmpProfileSettings.vue').default,
                        meta: {
                            requiresAuth: true,
                            title: 'OnBlick ESS - Employee Profile'
                        }
                    },
                    {
                        path: 'timezone',
                        name: "employee-timezone",
                        component: EmpChangeTimezone, //require('@/components/ESSProfile/ESSSettings/EmpChangeTimezone.vue').default,
                        meta: {
                            requiresAuth: true,
                            title: 'OnBlick ESS - Employee Timezone'
                        }
                    },
                    {
                        path: 'alerts',
                        name: "employee-alerts",
                        component: EmpAlertSettings, //require('@/components/ESSProfile/ESSSettings/EmpAlertSettings.vue').default,
                        meta: {
                            requiresAuth: true,
                            title: 'OnBlick ESS - Employee Alerts'
                        }
                    },
                ]
                // meta: {
                //   requiresAuth: true,
                //   title: 'OnBlick ESS - Employee Settings'
                // }
        },
        //Trainees
        {
            name: "ReportingEmployees",
            path: "/ReportingEmployees",
            component: ReportingEmployees,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS -Reporting Employees '
            },
            children: [{
                    path: "supervisor-form-i983",
                    name: "supervisor-form-i983",
                    props: true,
                    component: require('@/components/ESSProfile/FormI983.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS -Reporting Employees '
                    }
                },

                {
                    name: "employee-tasks-trainee",
                    path: "employee-tasks-trainee",
                    component: require('@/components/ESSProfile/Tasks/Task.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee Tasks'
                    }
                },

                {
                    name: "employee-evaluation-trainee",
                    path: "employee-evaluation-trainee",
                    component: require('@/components/ESSProfile/Tasks/Evaluation.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee Evaluation'
                    }
                },
                {
                    name: "employee-LeaveReport-trainee",
                    path: "employee-LeaveReport-trainee",
                    component: require('@/components/ESSProfile/LeaveManagement/LeaveReport.vue').default,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee Leave Report'
                    }
                },
            ]
        },
        //ESS FDNS
        {
            // name: "ess-fdns-visit-question",
            path: "/ess-fdns-visit-question",
            component: FDNS,
            children: [{
                    path: '',
                    name: "ess-fdns-visit-question",
                    path: "/ess-fdns-visit-question",
                    component: EmployeeSpecificQuestions,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee FDNS'
                    }
                },

                {
                    name: "ess-fdns-visit-history",
                    path: "/ess-fdns-visit-history",
                    component: FDNSVisitHistoryTab,
                    meta: {
                        requiresAuth: true,
                        title: 'OnBlick ESS - Employee FDNS Visit History'
                    }
                }
            ]
        },

        //ESS FDNS Report
        {
            name: "ess-fdns-report-visit",
            path: "ess-fdns-report-visit",
            component: ReportFDNSVisit,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Employee FDNS Report'
            }

        },
        //ESS Dashboard
        {
            name: "ess-dashboard",
            path: "/ess-dashboard",
            component: ESSDashboard,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Employee Dashboard'
            }
        },
        //view all alerts
        {
            name: "view-all-alerts",
            path: "/view-all-alerts",
            component: AlertViewAll,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Employee Alerts'
            }
        },
        //H-1B-CheckList-Documents
        {
            name: "H1BPetitionEmpChecklistDocs",
            path: "/H1BPetitionEmpChecklistDocs",
            component: H1BPetitionEmpChecklistDocs,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Employee Dashboard'
            }
        },
        {
            name: 'electronic-formi539',
            path: '/electronic-formi539/:id/:type/:index',
            component: require('@/components/ESSProfile/FormI539/ElectronicFormI539.vue').default,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Form I539 '
            }
        },

        {
            name: "add-new-project",
            path: "/add-new-project",
            component: AddNewProject,
            meta: {
                requiresAuth: true,
                title: 'OnBlick ESS - Add Project'
            }
        },

        {
            path: "*",
            component: PageNotFound,
            meta: {
                title: "404 - Page Not Found",
                anonymous: true
            }
        },
        {
            path: "/health-check",
            component: HealthCheck,
            meta: {
                title: "Onblick ESS- Health check",
                anonymous: true
            }
        }
    ]
});

// Nativation guards
router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!window.ajax.loggedIn()) {
            // next({
            //     name: 'LoginPage',
            //     query: {
            //         redirect: to.fullPath
            //     }
            // })
            window.location.href = c.WSO2LOGOUTURL;
        } else {
            localStorage.setItem("LastActivityTime", new Date());
            next()
        }
    } else {
        next() // make sure to always call next()!
    }
})



export default router;


// WEBPACK FOOTER //
// ./src/router/index.js